import { noop } from 'lodash-es';
import * as actionTypes from '../constants/actionTypes';
import { createProjectConfig, createPartialProjectConfig, } from '../createProjectConfig';
export function setProject(data) {
    return {
        type: actionTypes.SET_PROJECT,
        project: createProjectConfig(data),
    };
}
export function setPartialProject(data) {
    return {
        type: actionTypes.SET_PROJECT,
        project: createPartialProjectConfig(data),
    };
}
export function loadProject(projectID, token) {
    return loadFullProject(projectID, token);
}
export function loadFullProject(id, token) {
    return {
        type: actionTypes.LOAD_FULL_PROJECT,
        id: id,
        token: token,
    };
}
export function loadFullProjectStarting(id) {
    return {
        type: actionTypes.LOAD_FULL_PROJECT_STARTING,
        id: id,
    };
}
export function loadFullProjectDone(project, token) {
    return {
        type: actionTypes.LOAD_FULL_PROJECT_DONE,
        project: project,
        token: token,
    };
}
export function loadFullProjectFailed(id, err) {
    return {
        type: actionTypes.LOAD_FULL_PROJECT_FAILED,
        id: id,
        err: err,
    };
}
export function loadProjectPreview(id, screenID, token) {
    return {
        type: actionTypes.LOAD_PROJECT_PREVIEW,
        id: id,
        screenID: screenID,
        token: token,
    };
}
export function loadProjectPreviewStarting(id) {
    return {
        type: actionTypes.LOAD_PROJECT_PREVIEW_STARTING,
        id: id,
    };
}
export function loadProjectPreviewDone(project) {
    return {
        type: actionTypes.LOAD_PROJECT_PREVIEW_DONE,
        project: project,
    };
}
export function loadProjectPreviewFailed(id, err) {
    return {
        type: actionTypes.LOAD_PROJECT_PREVIEW_FAILED,
        id: id,
        err: err,
    };
}
export function play(projectID) {
    return function (dispatch) {
        dispatch(loadFullProject(projectID));
        dispatch({
            type: actionTypes.PLAY,
        });
    };
}
export function notFound(id) {
    return {
        type: actionTypes.NOT_FOUND,
        id: id,
    };
}
export function passwordRequired(id) {
    return {
        type: actionTypes.PASSWORD_REQUIRED,
        id: id,
    };
}
export function verifyPassword(projectID, password) {
    var url = "/api/project/verify/" + projectID + "/";
    var data = new FormData();
    data.append('password', password);
    return function (dispatch) {
        dispatch(verifyPasswordInProgress());
        return fetch(url, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
        })
            .then(function (response) {
            if (response.ok) {
                dispatch(passwordValid());
                return response.json();
            }
            if (response.status === 403) {
                dispatch(passwordInvalid());
            }
            // TODO dispatch action for other errors
            throw new Error("Password verification error: " + response.statusText);
        })
            .then(function (responseData) {
            var token = responseData.token;
            dispatch(loadProject(projectID, token));
        }, noop);
    };
}
function verifyPasswordInProgress() {
    return {
        type: actionTypes.VERIFY_PASSWORD,
    };
}
function passwordInvalid() {
    return {
        type: actionTypes.PASSWORD_INVALID,
    };
}
function passwordValid() {
    return {
        type: actionTypes.PASSWORD_VALID,
    };
}
export function setIsDownloaded(isDownloaded) {
    return {
        type: actionTypes.SET_IS_DOWNLOADED,
        isDownloaded: isDownloaded,
    };
}
export function setShowTouchIndicators(showTouchIndicators) {
    return {
        type: actionTypes.SET_SHOW_TOUCH_INDICATORS,
        showTouchIndicators: showTouchIndicators,
    };
}
export function setCanvasEaselURLs(canvasEaselHost) {
    return {
        type: actionTypes.SET_CANVAS_EASEL_URLS,
        canvasEaselHost: canvasEaselHost,
    };
}
export function setProjectPlan(plan) {
    return {
        type: actionTypes.SET_PROJECT_PLAN,
        plan: plan,
    };
}
export function setFrameless(isFrameless) {
    return {
        type: actionTypes.SET_FRAMELESS,
        isFrameless: isFrameless,
    };
}
export function setIsBasic(isBasic) {
    return {
        type: actionTypes.SET_BASIC,
        isBasic: isBasic,
    };
}
